import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router, Event } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ApiService } from '../../services/api.service';
import { CommonService } from '../../services/common/common.service';
import { SweetSpotMenuType, SweetSpotSubheaderMenuType } from '../../enum/enum';
import { LanguageService } from '../../services/languageService/language-service.service';
import { TranslateService } from '@ngx-translate/core';
import { SweetSpotSharedService } from '../../shared/sweetspot-shared.service';


@Component({
  selector: 'app-sweet-spot-manage-layout',
  templateUrl: './sweet-spot-manage-layout.component.html',
  styleUrl: './sweet-spot-manage-layout.component.scss',
})
export class SweetSpotManageLayoutComponent implements OnInit {
  selectedMenuType :string = '';
  currentDescription: string = '';
  activeTab: string = '';
  SweetSpotId: number = 0;
  sweetspotForm: FormGroup;

  houseHoldStatusCount: number = 0;
  demographicsCount: number = 0;
  geoGraphicsCount: number = 0;
  drivingRecordCount: number = 0;
  vehicleCount: number = 0;
  applicabilityCount: number = 0;
  contactPreferenceCount: number = 0;
  leadgenerationCount: number = 0;
  currentCarrierCount: number = 0;
  coverageount: number = 0;
  sweetspotContentData: any[] = [];
  tabTitles: { [key: string]: string } = {};
  tabDescriptions: { [key: string]: string } = {};
  selectedLang: string = ''
  sortedData: any[] = [];
  MenuTypeToLabelMap: { [key: number]: string } = {
    [SweetSpotMenuType.Demographics]: 'demographics',
    [SweetSpotMenuType.Geographic]: 'geographic',
    [SweetSpotMenuType.HouseHoldStatus]: 'house-hold-status',
    [SweetSpotMenuType.DrivingRecord]: 'driving-record',
    [SweetSpotMenuType.VehicleInformation]: 'vehicle-information',
    [SweetSpotMenuType.CurrentCarrierHistory]: 'current-carrier-histoy',
    [SweetSpotMenuType.CoverageLimit]: 'coverage-limit',
    [SweetSpotMenuType.SweetspotsApplicability]: 'sweetspot-applicability',
    [SweetSpotMenuType.CustomerContactPreference]: 'customer-contact-preference',
    [SweetSpotMenuType.LeadGenerationSource]: 'lead-generation-source',
  };
  // MenuTypeToLabelMapSubheader: { [key: number]: string } = {
  //   [SweetSpotSubheaderMenuType.martialStatus]: 'martialStatus',
  //   [SweetSpotSubheaderMenuType.gender]: 'gender',
  //   [SweetSpotMenuType.HouseHoldStatus]: 'house-hold-status',
  //   [SweetSpotMenuType.DrivingRecord]: 'driving-record',
  //   [SweetSpotMenuType.VehicleInformation]: 'vehicle-information',
  //   [SweetSpotMenuType.CurrentCarrierHistory]: 'current-carrier-histoy',
  //   [SweetSpotMenuType.CoverageLimit]: 'coverage-limit',
  //   [SweetSpotMenuType.SweetspotsApplicability]: 'sweetspot-applicability',
  //   [SweetSpotMenuType.CustomerContactPreference]: 'customer-contact-preference',
  //   [SweetSpotMenuType.LeadGenerationSource]: 'lead-generation-source',
  // };
 constructor(
  private route: ActivatedRoute,
  private router: Router,
  private formBuilder: FormBuilder,
  private toastr: ToastrService,
  private apiservice: ApiService,
  private url: ApiUrlHelper,
  private commonService: CommonService,
  private languageService: LanguageService,
  private translate: TranslateService,
  private sharedService: SweetSpotSharedService
) {
  this.selectedLang = this.languageService.getLanguage();  // 'eng' | 'spa'

  // 2️⃣ Shared service → assign description when data arrives
  this.sharedService.subHeaderData$.subscribe(data => {
    if (data) {
        // this.selectedMenuType = this.MenuTypeToLabelMapSubheader[data.tabId];
      this.currentDescription =
        this.selectedLang === 'spa'
          ? data.SpanishDescription
          : data.EnglishDescription;
    }
  });

  // 3️⃣ Language change → update all tab titles + descriptions + shared service content
  this.languageService.language$.subscribe(() => {
    this.selectedLang = this.languageService.getLanguage();

    // shared service description needs to update as well
    const latestData = this.sharedService['subHeaderDataSource'].getValue();
    if (latestData) {
      this.currentDescription =
        this.selectedLang === 'spa'
          ? latestData.SpanishDescription
          : latestData.EnglishDescription;
    }

    // update tab titles/descriptions
    this.sweetspotContentData.forEach(item => {
      const label = this.MenuTypeToLabelMap[item.MenuType];
      if (label) {
        this.tabTitles[label] =
          this.selectedLang === 'spa'
            ? item.SpanishHeaderContentTitle
            : item.EnglishHeaderContentTitle;

        this.tabDescriptions[label] =
          this.selectedLang === 'spa'
            ? item.SpanishHeaderContentDescription
            : item.EnglishHeaderContentDescription;
      }
    });
  });

  // 4️⃣ Form
  this.sweetspotForm = this.formBuilder.group({
    SweetSpotName: ['', Validators.required],
  });

  // 5️⃣ Read Query Params
  this.route.queryParams.subscribe(params => {
    const DecryptedId = this.getDecrypted(params['id']);
    const DecryptedName = this.getDecrypted(params['name']);

    if (DecryptedId) this.SweetSpotId = Number(DecryptedId);

    if (DecryptedName)
      this.sweetspotForm.patchValue({
        SweetSpotName: DecryptedName
      });
  });

  // 6️⃣ Router events
  this.router.events.subscribe(() => {
    this.activeTab = this.route.firstChild?.snapshot.url[0]?.path || '';
  });

  // 7️⃣ Load sweetspot content
  this.getSweetspotContentHeaderContent();
}



  ngOnInit(): void {
    const nav = this.router.getCurrentNavigation();
    const data = nav?.extras.state?.['apiData'];

    console.log("Navigation API Data:", data);
//  Object.keys(this.MenuTypeToLabelMapSubheader).forEach(key => {
//     const label = this.MenuTypeToLabelMapSubheader[+key];
//     this.MenuTypeToLabelMapSubheader[label] = +key;

//   });

    // Get current language only once
    this.selectedLang = this.languageService.getLanguage();   // 'eng' or 'spa'

    // Listen shared service for new description data
    this.sharedService.subHeaderData$.subscribe(data => {
      if (data) {
        const english = data.EnglishDescription;
        const spanish = data.SpanishDescription;

        // Assign based on current selected language
        this.currentDescription =
          this.selectedLang === 'spa' ? spanish : english;
          this.getSweetspotContentHeaderContent()
      }
    });

    // Form initialization
    this.sweetspotForm = this.formBuilder.group({
      SweetSpotName: ['', [Validators.required]],
    });

    // For query params
    this.route.queryParams.subscribe(params => {
      const DecryptedId = this.getDecrypted(params['id']);
      const DecryptedName = this.getDecrypted(params['name']);

      if (DecryptedId) {
        this.SweetSpotId = Number(DecryptedId);
      }
      if (DecryptedName) {
        this.sweetspotForm.patchValue({
          SweetSpotName: DecryptedName
        });
      }
    });

    // Detect route change
    this.router.events.subscribe(event => {
      this.activeTab = this.route.firstChild?.snapshot.url[0]?.path || '';
    });

    // Load data
    this.getSweetspotContentHeaderContent();

    // Listen when language changed → update tab titles + description
    this.languageService.language$.subscribe(() => {
      this.selectedLang = this.languageService.getLanguage();

      // Update descriptions coming from shared service
      this.sharedService.subHeaderData$.subscribe(data => {
        if (data) {
          this.currentDescription =
            this.selectedLang === 'spa'
              ? data.SpanishDescription
              : data.EnglishDescription;
        }
      });

      // Update all tabs
      this.sweetspotContentData.forEach(item => {
        const menuType = item.MenuType;
        const label = this.MenuTypeToLabelMap[menuType];

        if (label) {
          this.tabTitles[label] =
            this.selectedLang === 'spa'
              ? item.SpanishHeaderContentTitle
              : item.EnglishHeaderContentTitle;

          this.tabDescriptions[label] =
            this.selectedLang === 'spa'
              ? item.SpanishHeaderContentDescription
              : item.EnglishHeaderContentDescription;
        }
      });
    });

    if (data) {
      // Assign it to variables, load the form, etc.

    }
  }


  getSweetspotContentHeaderContent() {
    const apiUrl = this.url.apiUrl.SweetSpotContentManagement.getSweetSpotContentManagementList;
    this.apiservice
      .doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response['Success']) {
            this.sweetspotContentData = response['Data'];
            this.initializeTabData();
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
  }
  initializeTabData() {
    this.sweetspotContentData.forEach((item) => {
      const menuType = item.MenuType;
      const label = this.MenuTypeToLabelMap[menuType];
      if (label) {
        this.tabTitles[label] = this.selectedLang === 'spa' ? item.SpanishHeaderContentTitle : item.EnglishHeaderContentTitle;
        this.tabDescriptions[label] = this.selectedLang === 'spa' ? item.SpanishHeaderContentDescription : item.EnglishHeaderContentDescription
      }
    });

    
    this.sharedService.subHeaderData$.subscribe(data => {
    if (data) {
      this.currentDescription =
        this.selectedLang === 'spa'
          ? data.SpanishDescription
          : data.EnglishDescription;
    }
  });


  }
  getEncrypted(data: any): string {
    return encodeURIComponent(btoa(this.commonService.Encrypt(data.toString())));
  }

  // getDecrypted(data: any): string {
  //   return this.commonService.Decrypt(atob(decodeURIComponent(data.toString())));
  // }

  getDecrypted(data: any): string {
    if (!data) {
      console.warn('getDecrypted: received undefined or null data');
      return '';
    }

    try {
      const decoded = decodeURIComponent(data.toString());
      const base64Decoded = atob(decoded);
      return this.commonService.Decrypt(base64Decoded);
    } catch (error) {
      console.error('getDecrypted: error during decryption', error);
      return '';
    }
  }


  goToPage(pageName: string) {
    this.router.navigate(["/sweet-spot-manage/" + pageName], { queryParams: { id: this.getEncrypted(this.SweetSpotId), name: this.getEncrypted(this.sweetspotForm.controls['SweetSpotName'].value.trim()) } });
  }

  saveSweetSpot() {
    const data = {
      SweetSpotId: this.SweetSpotId,
      SweetSpotName: this.sweetspotForm.controls['SweetSpotName'].value.trim()
    }
    let url = this.url.apiUrl.SweetSpotpipeline.SaveSweetSpotPipeline;
    this.apiservice.doPost(url, data).subscribe({
      next: (value) => {
        if (value.Success) {
          this.toastr.success(this.translate.instant(value.Message));
          this.SweetSpotId = value.TAID;
          let encryptedId = this.getEncrypted(value.TAID.toString());
          let encryptedName = this.getEncrypted(data.SweetSpotName);
          const sweetspotData = { id: encryptedId, name: encryptedName };
          this.router.navigate(["/sweet-spot-manage/" + this.activeTab], { queryParams: sweetspotData });
        }
        else {
          this.toastr.error(this.translate.instant(value.Message));
        }
      },
      error: (err) => {
        console.error(err);
        this.toastr.error(this.translate.instant(err.Message));
      },
    });
  }

  subscribeToChildEmitter(componentRef: any) {
    componentRef.houseHoldToParent?.subscribe((res: any) => {
      this.houseHoldStatusCount = res;
    });
    componentRef.demographicToParent?.subscribe((res: any) => {
      this.demographicsCount = res;
    });
    componentRef.drivingRecordToParent?.subscribe((res: any) => {
      this.drivingRecordCount = res;
    });
    componentRef.geographicToParent?.subscribe((res: any) => {
      this.geoGraphicsCount = res;
    });
    componentRef.vehicleToParent?.subscribe((res: any) => {
      this.vehicleCount = res;
    });
    componentRef.applicabilityToParent?.subscribe((res: any) => {
      this.applicabilityCount = res;
    });
    componentRef.contactPreferenceToParent?.subscribe((res: any) => {
      this.contactPreferenceCount = res;
    });
    componentRef.leadgenerationToParent?.subscribe((res: any) => {
      this.leadgenerationCount = res;
    });
    componentRef.currentCarrierToParent?.subscribe((res: any) => {
      this.currentCarrierCount = res;
    })
    componentRef.coverageToParent?.subscribe((res: any) => {
      this.coverageount = res;
    })
  }

  goBack() {
    this.router.navigate(['/sweet-spot-pipeline']);
  }
}
